import { scheduleOnce } from '@ember/runloop';
import Route from '@ember/routing/route';

export default Route.extend({
  actions: {
    didTransition() {
      let mcController = this.controllerFor('messageCenter');
      mcController.set('routeSegment', {threadId: null, view: 'archive'});

      scheduleOnce('afterRender', this, function() {
        mcController.get('_DOM_afterTransitionSetup')();
      });
    }
  }
});
